function get_feed_campaign_status(campaign) {
  return String(campaign?.status?.name || campaign?.status || "").trim().toLowerCase();
}

function get_feed_campaigns(response) {
  if (Array.isArray(response?.data?.data)) {
    return response.data.data;
  }

  if (Array.isArray(response?.data)) {
    return response.data;
  }

  return [];
}

function get_feed_campaign_goal_amount(campaign) {
  return Number(campaign?.goal_amount || campaign?.goal || 0);
}

function get_feed_campaign_current_amount(campaign) {
  return Number(campaign?.current_amount || campaign?.amount_raised || campaign?.raised_amount || 0);
}

function get_feed_campaign_cover_image(campaign) {

  const campaign_file = campaign?.files?.find?.(
    (file) => file?.image_url
  );

  return (
    campaign_file?.image_url
    || 'https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/campaign_donation_default.webp'
  );
}

function get_feed_campaign_progress(campaign) {
  const goal_amount = get_feed_campaign_goal_amount(campaign);
  if (!goal_amount) {
    return 0;
  }

  const amount = Number((get_feed_campaign_current_amount(campaign) / goal_amount) * 100);
  if (!Number.isFinite(amount)) {
    return 0;
  }

  return Math.min(100, Number(amount.toFixed(1)));
}

function get_feed_campaign_category_label(campaign) {
  return campaign?.category?.name;
}

function format_feed_campaign_currency(value) {
  return `R ${Number(value || 0).toLocaleString("en-ZA", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`;
}

function get_feed_campaign_href(campaign) {
  if (!campaign?.id) {
    return "/donation_campaigns";
  }

  return `/donation_campaigns?campaign_id=${campaign.id}`;
}

function map_feed_campaign_card(campaign) {
  return ({
    id: campaign?.id,
    title: campaign?.name,
    category: get_feed_campaign_category_label(campaign),
    cover_image: get_feed_campaign_cover_image(campaign),
    progress: get_feed_campaign_progress(campaign),
    creater: campaign?.created_by_profile?.user?.id,
    raised: format_feed_campaign_currency(
      get_feed_campaign_current_amount(campaign)
    ),
    goal: format_feed_campaign_currency(
      get_feed_campaign_goal_amount(campaign)
    ),
    href: get_feed_campaign_href(campaign),
  });
}

export function get_pinned_feed_campaign_cards(response) {
  return get_feed_campaigns(response)
    .filter(
      (campaign) => get_feed_campaign_status(campaign) === "active" && campaign?.is_pinned
    )
    .map(map_feed_campaign_card);
}
